import React from 'react';
import { Target, Send, Filter, ShieldCheck } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Target, Send, Filter, ShieldCheck };

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-semibold">What we do</p>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-[#0b0f0d] leading-tight">
            A lead engine engineered for the trades.
          </h2>
          <p className="mt-5 text-[#4a4f4c] text-lg">
            We are not another agency selling shiny promises. Trusted Home Leads runs the top of your funnel, generating and delivering qualified leads straight to your team, for contractors doing $30k to $5M per month.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={i} className="group relative rounded-2xl border border-[#e8e4d8] bg-white p-8 hover:border-[#0b0f0d]/30 hover:shadow-lg hover:shadow-[#0b0f0d]/5">
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-12 h-12 rounded-xl bg-[#0b0f0d] flex items-center justify-center text-white">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-[#0b0f0d]">{s.title}</h3>
                    <p className="mt-2 text-[#4a4f4c] text-sm leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
